// Syncs the variant selector dropdown(s) when a customer clicks a product
// photo thumbnail that is associated with a specific variant option (e.g. a
// colour), so the customer can't add the wrong colour/variant to cart while
// looking at a different colour's photo.
//
// Works alongside the theme's existing thumbnail click handler (in shop.js),
// which only swaps the main photo. This does not touch that behaviour — it
// just also updates the option selector(s) so the visible dropdown matches
// what's on screen.
//
// Depends on data-option1 / data-option2 / data-option3 attributes emitted
// by the product template's thumbnail loop: each attribute is only present
// when every variant that shares that photo agrees on that option's value,
// so (for example) a colour photo shared across multiple sizes only updates
// the Colour selector and leaves the customer's Size choice alone.
jQuery(function ($) {
  $('#productThumbs').on('click', 'a.product-photo-thumb', function () {
    var $thumb = $(this);
    var $selectors = $('.single-option-selector');

    if (!$selectors.length) {
      return;
    }

    for (var i = 1; i <= 3; i++) {
      var optionValue = $thumb.attr('data-option' + i);
      if (optionValue) {
        var $selector = $selectors.eq(i - 1);
        if ($selector.length && $selector.val() !== optionValue) {
          $selector.val(optionValue).trigger('change');
        }
      }
    }
  });
});
